import React from "react";

const SMMProStartIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.40279 7.96629L6.55236 6.20938L8.42494 1.37791C8.62022 0.87403 9.37978 0.874028 9.57507 1.37791L11.4476 6.20938L16.5972 7.96629C17.1343 8.14951 17.1343 8.86215 16.5972 9.04538L11.4476 10.8023L9.57507 15.6337C9.37978 16.1376 8.62022 16.1376 8.42494 15.6337L6.55236 10.8023L1.4028 9.04538C0.865737 8.86215 0.865734 8.14951 1.40279 7.96629Z"
        stroke="white"
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SMMProStartIcon;
